
export const CLEAR_ADMIN_PAGINATION_STATE = "CLEAR_ADMIN_PAGINATION_STATE";
export const GET_ADMIN_PAGINATION_STATE = "CLEAR_ADMIN_PAGINATION_STATE";
export const SET_ACCOUNTS_PAGINATION_STATE = "SET_ACCOUNTS_PAGINATION_STATE";
export const SET_USERS_PAGINATION_STATE = "SET_USERS_PAGINATION_STATE";
export const SET_EMAILTEMPLATES_PAGINATION_STATE = "SET_EMAILTEMPLATES_PAGINATION_STATE";

